export default __webpack_public_path__ + "static/media/G0002.50d7abbc.png";